import * as React from "react";
import { ITicketGroup } from "@nkr/models/index";
import { Modal, Button } from "react-bootstrap";

interface IProps {
    show: boolean,
    data: ITicketGroup,
    onDelete: (groupId: number) => void,
    onCancel: () => void
}

class GroupDelete extends React.Component<IProps, {}> {
    handleDelete = () => {
        this.props.onDelete(this.props.data.id);
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        if (this.props.data == null)
            return null;

        return (
            <>
                <Modal show={this.props.show} onHide={this.handleCancel}>
                    <Modal.Header className="h4" closeButton>
                        Delete Ticket Group
                    </Modal.Header>

                    <Modal.Body>
                        <div className="alert alert-danger text-center">
                            WARNING! Deleting a ticket group is irreversible!
                        </div>

                        <div>Please confirm that you want to delete the following ticket group: <strong>{this.props.data.name}</strong></div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={this.handleDelete}>Yes, Delete</Button>
                        <Button bsStyle="primary" onClick={this.handleCancel}>No, Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default GroupDelete;